import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ChatState, ConversationStatusType } from '../../../../ts/types/chat';

export interface ChatNewState {
  messageSound: string | null;
  sideBarOpen: boolean;
  chatInputs: { [sessionId: string]: string };
  view: {
    selectedStatus?: ConversationStatusType;
    selectedAgent?: string;
    selectedDepartment?: string;
    selectedBrain?: string;
    selectedSort?: 'newest' | 'oldest';
    selectedView?: string;
    title?: string;
  };
}

export const defaultState: ChatNewState = {
  messageSound: null,
  sideBarOpen: true,
  chatInputs: {},
  view: {
    selectedStatus: 'open',
    selectedAgent: '',
    selectedDepartment: '',
    selectedBrain: '',
    selectedSort: 'newest',
    selectedView: '',
    title: 'me',
  },
};

const slice = createSlice({
  name: 'chatNew',
  initialState: defaultState,
  reducers: {
    setView: (state, action: PayloadAction<ChatState['view']>) => {
      const view = action.payload;
      state.view = { ...state.view, ...view };
    },
    setMessageSound: (state, action) => {
      const messageSound = action.payload;
      state.messageSound = messageSound;
    },
    setSideBarOpen: (state, action: PayloadAction<boolean>) => {
      const sideBarOpen = action.payload;
      state.sideBarOpen = sideBarOpen;
    },

    setChatInput: (state, action: PayloadAction<{ sessionId: string; text: string }>) => {
      const { sessionId, text } = action.payload;
      state.chatInputs[sessionId] = text;
    },
    clearChatInput: (state, action: PayloadAction<string>) => {
      const sessionId = action.payload;
      delete state.chatInputs[sessionId];
    },
    resetView: (state) => {
      state.view = defaultState.view;
    },
  },
});

export const { setMessageSound, setSideBarOpen, setView, resetView, setChatInput, clearChatInput } =
  slice.actions;

export default slice.reducer;
